import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {ApiControllerBase} from './api-controller-base';

export type BonusManagerController_GetEligiblePromotionCodesResponse = Array<string>;

export class BonusManagerController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/bonusManager/'
	}
	getEligiblePromotionCodes(): Promise<BonusManagerController_GetEligiblePromotionCodesResponse> {
		return this._httpPost('getEligiblePromotionCodes');
	}

}

export type ABTestingController_GetTestsForAnonymousPlayerRequest = {
	anonymousPlayerId: string;
	brandId: number;
	subBrandId: number;
	countryCode: string;
	isMobile: boolean;
};

export type ABTestingController_GetTestsForAnonymousPlayerResponse = {
	Features: Record<string, {
		TestId: number;
		GroupName: string;
		FeatureName: string;
		Properties: Record<string, any>;
	}>;
	AnonymousPlayerId: string;
};

export class ABTestingController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/abTesting/'
	}
	getTestsForAnonymousPlayer(request: ABTestingController_GetTestsForAnonymousPlayerRequest): Promise<ABTestingController_GetTestsForAnonymousPlayerResponse> {
		return this._httpPost('getTestsForAnonymousPlayer', request);
	}

}

export type InsightController_GetLiveCasinoGameRecommendationsForPlayerRequest = {
	engineType: number;
};

export type InsightController_GetLiveCasinoGameRecommendationsForPlayerResponse = {
	Engine: string;
	GameTypes: Array<number>;
	ErrorCode: number;
	ErrorDescription: string;
};

export type InsightController_GetCasinoRecommendedDynamicListsForPlayerRequest = {
	listsIDs: Array<string>;
};

export type InsightController_GetCasinoRecommendedDynamicListsForPlayerResponse = Record<number, number>;

export class InsightController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/insight/'
	}
	getLiveCasinoGameRecommendationsForPlayer(request: InsightController_GetLiveCasinoGameRecommendationsForPlayerRequest): Promise<InsightController_GetLiveCasinoGameRecommendationsForPlayerResponse> {
		return this._httpPost('getLiveCasinoGameRecommendationsForPlayer', request);
	}

	getCasinoRecommendedDynamicListsForPlayer(req: InsightController_GetCasinoRecommendedDynamicListsForPlayerRequest): Promise<InsightController_GetCasinoRecommendedDynamicListsForPlayerResponse> {
		return this._httpPost('getCasinoRecommendedDynamicLists', req);
	}

}

export type NetPositionController_IntializeNetPositionForGameTypeRequest = {
	GameType: number;
	Cid: number;
	PlayerSessionId: number;
};

export type NetPositionController_IntializeNetPositionForGameTypeResponse = {
	code: number;
	message: string;
	response_time: number;
	ErrorCode: number;
	ErrorDescription: string;
};

export class NetPositionController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/netPosition/'
	}
	intializeNetPositionForGameType(request: NetPositionController_IntializeNetPositionForGameTypeRequest): Promise<NetPositionController_IntializeNetPositionForGameTypeResponse> {
		return this._httpPost('initialize', request);
	}

}

export type RestrictionRulerController_GetRestrictionActionsRequest = {
	RequestedAction: string;
};

export type RestrictionRulerController_GetRestrictionActionsResponse = {
	actions: Array<{
		type: string;
		actionData: any;
		orderId: number;
	}>;
	ErrorCode: number;
	ErrorDescription: string;
};

export type RestrictionRulerController_NotifyRestrictionActionPerformedRequest = {
	restrictionRuleActionType: string;
	actionData: string;
};

export class RestrictionRulerController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/restrictionRuler/'
	}
	getRestrictionActions(request: RestrictionRulerController_GetRestrictionActionsRequest): Promise<RestrictionRulerController_GetRestrictionActionsResponse> {
		return this._httpPost('getRestrictionActions', request);
	}

	notifyRestrictionActionPerformed(clientRequest: RestrictionRulerController_NotifyRestrictionActionPerformedRequest): Promise<void> {
		return this._httpPost('notifyRestrictionActionPerformed', clientRequest);
	}

}

export type HistoryController_GetHistoryRequest = {
	pageNumber: number;
	pageSize?: number;
	fromLastDays: number;
	requestKey?: string;
	minDate?: string;
	maxDate?: string;
};

export type HistoryController_GetHistoryResponse = {
	GameHistoryData: Array<{
		AdditionalData: any;
		AmountCurrencyISOCode: string;
		AvailableMoneyPerOffering: number;
		AllowedPlatformType: string;
		BetAmount: number;
		Date: string;
		TimeSincePlay: string;
		DateInTimeZone?: string;
		FreePlayCurrentAmount?: number;
		FreePlayWinningAmount?: number;
		GameId: string;
		GameTypeId: number;
		OriginalWinningsAmount?: number;
		ProductPackageID: number;
		ProfitAmount: number;
		SubBrandId?: number;
		VatBetFee: number;
		VendorName: string;
		FreePlayReachedMaxWinCap?: boolean;
		CompanyName: string;
		GameGroupId: number;
		IsSupportDetailedHistory: boolean;
		IsBigWin: boolean;
	}>;
	PagingData: Array<{
		RequestKey: string;
		PageNumber: number;
		MinDate: string;
		MaxDate: string;
	}>;
};

export type HistoryController_GetGameSessionHistoryRequest = {
	pageNumber: number;
	pageSize?: number;
	fromLastDays: number;
	requestKey?: string;
	minDate?: string;
	maxDate?: string;
};

export type HistoryController_GetGameSessionHistoryResponse = {
	GameHistoryData: Array<{
		CurrencyCodeISO3: string;
		GameGroupId?: number;
		GameSessionId: string;
		GameTypeId?: number;
		SessionEndDateTime: string;
		SessionBalance: number;
		TotalBets: number;
		TotalWins: number;
		VendorName: string;
		CompanyName: string;
	}>;
	PagingData: Array<{
		RequestKey: string;
		PageNumber: number;
		MinDate: string;
		MaxDate: string;
	}>;
};

export class HistoryController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/history/'
	}
	getHistory(req: HistoryController_GetHistoryRequest): Promise<HistoryController_GetHistoryResponse> {
		return this._httpPost('getGammingHistory', req);
	}

	getGameSessionHistory(req: HistoryController_GetGameSessionHistoryRequest): Promise<HistoryController_GetGameSessionHistoryResponse> {
		return this._httpPost('getSessionHistory', req);
	}

}

export type UserController_UpdateRealityCheckReminderRequest = {
	realityCheckIntevalMin: number;
};

export type UserController_GetUserGameOrientationResponse = {
	groupId?: number;
	groupName: string;
};

export type UserController_SelfExclusionPanicRequest = {
	timezoneOffset: number;
	productPackage: number;
};

export type UserController_SelfExclusionPanicResponse = {
	errorID: number;
	errorDescription: string;
	hasErrors: boolean;
};

export type UserController_GetPlayerLimitsResponse = {
	displayableLimits: Array<{
		limitName: string;
		limitPeriods: Array<{
			value: number;
			typeId: number;
			unit: string;
			currency: string;
		}>;
	}>;
	ErrorCode: number;
	ErrorDescription: string;
};

export class UserController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/user/'
	}
	updateRealityCheckReminder(request: UserController_UpdateRealityCheckReminderRequest): Promise<any> {
		return this._httpPost('updateRealityCheckData', request);
	}

	getUserGameOrientation(): Promise<UserController_GetUserGameOrientationResponse> {
		return this._httpPost('getUserGameOrientation');
	}

	selfExclusionPanic(request: UserController_SelfExclusionPanicRequest): Promise<UserController_SelfExclusionPanicResponse> {
		return this._httpPost('selfExclusionPanic', request);
	}

	getPlayerLimits(): Promise<UserController_GetPlayerLimitsResponse> {
		return this._httpPost('getPlayerLimits');
	}

}

export class ApiService extends ServiceBase {
	constructor(services: IServiceFactoryExtended) {
		super(services);
		this.bonusManagerController = new BonusManagerController(services);
		this.aBTestingController = new ABTestingController(services);
		this.insightController = new InsightController(services);
		this.netPositionController = new NetPositionController(services);
		this.restrictionRulerController = new RestrictionRulerController(services);
		this.historyController = new HistoryController(services);
		this.userController = new UserController(services);
	}
	readonly bonusManagerController: BonusManagerController;
	readonly aBTestingController: ABTestingController;
	readonly insightController: InsightController;
	readonly netPositionController: NetPositionController;
	readonly restrictionRulerController: RestrictionRulerController;
	readonly historyController: HistoryController;
	readonly userController: UserController;
}
